"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "codroipo": {
    "7eb7ee8e": [{
      "hkey": "5c7cadcc",
      "slug": "rivolto-lonca",
      "name": "Rivolto-Lonca",
      "primary": true,
      "skipSearch": false
    }],
    "lonca": [{
      "hkey": "5c7cadcc",
      "slug": "rivolto-lonca",
      "name": "Rivolto-Lonca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "codroipo"
    }],
    "25c955ed": [{
      "hkey": "16f70d95",
      "slug": "goricizza-pozzo",
      "name": "Goricizza-Pozzo",
      "primary": true,
      "skipSearch": false
    }],
    "pozzo": [{
      "hkey": "16f70d95",
      "slug": "goricizza-pozzo",
      "name": "Goricizza-Pozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "codroipo"
    }],
    "37e5a1fc": [{
      "hkey": "5c7cadcc",
      "slug": "rivolto-lonca",
      "name": "Rivolto-Lonca",
      "primary": true,
      "skipSearch": false
    }],
    "rivolto": [{
      "hkey": "5c7cadcc",
      "slug": "rivolto-lonca",
      "name": "Rivolto-Lonca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "21ad96c9": [{
      "hkey": "16f70d95",
      "slug": "goricizza-pozzo",
      "name": "Goricizza-Pozzo",
      "primary": true,
      "skipSearch": false
    }],
    "goricizza": [{
      "hkey": "16f70d95",
      "slug": "goricizza-pozzo",
      "name": "Goricizza-Pozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;